import { useIsGlobalAdmin } from './useIsGlobalAdmin'
import { useIsSuperUser } from './useIsSuperUser'

/**
 * True when the user may read and edit the permissions matrix for their active
 * org.
 *
 * The client half of the server's `_matrix_scope`: the org's own global admin
 * governs that org, and Careforce staff govern whichever org they are switched
 * into. `useIsSuperUser()` is membership-based, so it holds while staff work
 * inside a customer org where their own role is Member — the case the server
 * admits through `is_careforce_super_user`.
 *
 * The sidebar entry and the route guard both read this, so the nav cannot
 * offer a page the guard then bounces the user off.
 */
export function useCanAdministerPermissions(): boolean {
  const isGlobalAdmin = useIsGlobalAdmin()
  const isSuperUser = useIsSuperUser()

  return isGlobalAdmin || isSuperUser
}
